// src/lib/memoryHint.js
// Local memory matcher — ports the mobile app's findRelevantMemory(). Given the
// character's structured memory and the user's message, it returns a short
// "memory_hint" string of only the relevant facts, which we send with the
// message so the AI recalls the right thing at the right moment (zero DB cost).

const MEMORY_WORDS = ["remember", "before", "last time", "earlier", "forgot", "again", "you know"];

export function findRelevantMemory(userMessage, structured, recentMessages = []) {
  if (!structured) return "";
  const msg = (userMessage || "").toLowerCase();
  const recent = recentMessages.slice(-8).map((m) => m.content || "").join(" ").toLowerCase();
  const lines = [];

  const scan = (obj, fmt) => {
    Object.entries(obj || {}).forEach(([name, data]) => {
      const key = name.toLowerCase();
      if (msg.includes(key) && !recent.includes(key)) lines.push(fmt(name, data));
    });
  };

  scan(structured.family_members, (n, d) => `• ${n}: ${JSON.stringify(d)}`);
  scan(structured.side_characters, (n, d) => `• ${n}: ${JSON.stringify(d)}`);
  scan(structured.world_facts, (n, v) => `• ${n}: ${typeof v === "string" ? v : JSON.stringify(v)}`);

  // Explicit recall words → include recent freeform notes.
  if (MEMORY_WORDS.some((w) => msg.includes(w))) {
    (structured.extra || []).slice(-5).forEach((note) => lines.push(`• ${note}`));
  }

  return lines.join("\n");
}
